;(function($, undefined){

    'use strict';

    var modeEnforced,
        isAnyModeEnforced,
        isMobileDevice,
        isMobileSubdomain,
        isMobileModeEnforced,
        isThirdParty,
        rnn;

    function getSwitchUrl(mode) {
        var domain,
            mobile_domain,
            desktop_domain;

        domain = window.location.host.replace(/^www/,"").replace(/^m/,"");
        mobile_domain = window.location.host.replace(/^www\./, "m.");
        desktop_domain = window.location.host.replace(/^m\./, "www.");
        if (mode === "mobile") {
            if (window.location.hostname.indexOf("www.") === 0) {
                return [window.location.protocol, "//", mobile_domain].join("");
            } else {
                // Fallback if @ a weird domain
                return [window.location.protocol, "//", "m.", domain].join("");
            }
        } else {
            return [window.location.protocol, "//", desktop_domain].join("");
        }
    }

    function setModeEnforced(mode, doRedirect) {
        var domain,
            mobile_domain,
            desktop_domain;

        domain = window.location.hostname.replace(/^www/,"").replace(/^m/,"");
        mobile_domain = window.location.hostname.replace(/^www\./, "m.");
        desktop_domain = window.location.hostname.replace(/^m\./, "www.");
        Cookies.set("mode_enforced", mode, { expires: 365, path: "/", domain: domain });
        if (typeof doRedirect !== "undefined") {
            if (mode === "mobile") {
                if (window.location.hostname.indexOf("www.") === 0) {
                    window.location.hostname = mobile_domain;
                } else {
                    // Fallback if @ a weird domain
                    window.location.hostname = ["m.", domain].join("");
                }
            } else {
                window.location.hostname = desktop_domain;
            }
        }
    }

    function initModeSwitcher() {
        var message;

        if (isMobileSubdomain) {
            var $desktop = $(".desktop"),
                desktopUrl = getSwitchUrl("desktop");
            if (!isAnyModeEnforced) {
                setModeEnforced("mobile");
            }
            $desktop.attr("href", desktopUrl);
            $desktop.on("click", function (event) {
                setModeEnforced("desktop");
            });
        } else {
            if (isAnyModeEnforced) {
                var isMobile = (/iphone|ipad|ipod|android|blackberry|mini|windows\sce|palm/i.test(navigator.userAgent.toLowerCase()));
                if(isMobile){
                    var $btnViewMobileSite = $("<a id='view_mobile_version' href='javascript:void();'><i class='icon24x24-mobile-sp-gray'></i>You're currently viewing our desktop site, click here to visit our <span>mobile site</span></a>"),
                        $latestBar = $(".latest-bar"),
                        $navBar = $(".sitenav");

                    //Add url
                    var mobileUrl = getSwitchUrl("mobile");
                    $btnViewMobileSite.attr('href', mobileUrl);

                    //Check has lastest bar, put the button sit under the lastest bar
                    //The .latest-bar will be search bar in finda.com.au
                    if($latestBar.length > 0) {
                        $btnViewMobileSite.addClass("fixed");
                        $btnViewMobileSite.insertAfter($latestBar);
                    } else { //Sit under nav bar
                        $btnViewMobileSite.insertAfter($navBar);
                    }
                    //Binding event
                    $btnViewMobileSite.bind("click", function (event) {
                        setModeEnforced("mobile");
                    });
                }
            }
        }

    }

    /*==========================================================================
        INITIALISATION AND EXPOSING OF VARS / FUNCITONS
    ==========================================================================*/

    function modeSwitcher() {
        if (!isThirdParty) {
            initModeSwitcher();
        }
    }

  // @TODO Pulled from mytributes/standalone. Should expose and use isMobile as a module/library function
  var isMobile = {
    Android: function() {
      return navigator.userAgent.match(/Android/i);
    },
    BlackBerry: function() {
      return navigator.userAgent.match(/BlackBerry/i);
    },
    iOS: function() {
      return navigator.userAgent.match(/iPhone|iPod/i);
    },
    Opera: function() {
      return navigator.userAgent.match(/Opera Mini/i);
    },
    Windows: function() {
      return navigator.userAgent.match(/IEMobile/i) || navigator.userAgent.match(/WPDesktop/i);
    },
    any: function() {
      return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows());
    }
  };

    modeEnforced = Cookies.get("mode_enforced");
    isAnyModeEnforced = !!modeEnforced;
    isMobileDevice = isMobile.any();
    isMobileSubdomain = window.location.hostname.indexOf("m.") === 0;
    isMobileModeEnforced = isAnyModeEnforced && modeEnforced === "mobile" && isMobileSubdomain;
    isThirdParty = !!window.header_only || !!window.footer_only;
    rnn = window.rnn;

    rnn.modules.register("modeSwitcher", {
        init: modeSwitcher
    });

})(jQuery);
